import { INSURANCE_FORM_ANALYTICS } from '@makemydeal/dr-shared-components';

/**
 * Analytics event contract for the customer card activity.
 *
 * The activity owns *when* and *which* event fires and emits a neutral event name through the
 * `onAnalyticsEvent` prop threaded from the host. The host owns *emission* — it maps each name to
 * whatever its own analytics stack expects (e.g. dispatching a host action). This keeps the activity
 * free of any host-specific analytics dependency, so different hosts can react differently.
 */
export const CUSTOMER_CARD_ANALYTICS = {
    ...INSURANCE_FORM_ANALYTICS,
    CLICKED_SHOW_CUSTOMER_SPD: 'CLICKED_SHOW_CUSTOMER_SPD',
    /** A sub-tab was clicked. `data.subTab` carries the `CustomerSubTabKey` that was selected. */
    CLICKED_CUSTOMER_SUB_TAB: 'CLICKED_CUSTOMER_SUB_TAB',
    CREDIT_CONSENT_CLICKED: 'CREDIT_CONSENT_CLICKED',
    CLICKED_ADD_BILLING_ADDRESS: 'CLICKED_ADD_BILLING_ADDRESS',
    CLICKED_HOUSING_EMPLOYMENT_ACCORDION: 'CLICKED_HOUSING_EMPLOYMENT_ACCORDION',
    CLICKED_ADD_PREVIOUS_EMPLOYMENT: 'CLICKED_ADD_PREVIOUS_EMPLOYMENT',
    CLICKED_ADD_ADDITIONAL_INCOME: 'CLICKED_ADD_ADDITIONAL_INCOME',
    CLICKED_ADD_PREVIOUS_ADDRESS: 'CLICKED_ADD_PREVIOUS_ADDRESS'
} as const;

/** New Relic event names the activity reports directly. Referenced by NRQL, so do not rename. */
export const CUSTOMER_CARD_NR_EVENTS = {
    RENDERED_WITHOUT_BUYER: 'CustomerCard:RenderedWithoutBuyer',
    RENDER_CRASH: 'CustomerCard:RenderCrash'
} as const;
